import React from 'react';
import { Settings, Link2, AlertCircle } from 'lucide-react';
import { mockApps } from '../mocks/automationData';
import { AppLogo } from './AppLogo';
export function ConnectedAppsPanel() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2831">
      {mockApps.map(app => <div key={app.id} className="bg-[var(--colors-background-card)] border border-[var(--colors-border-light)] rounded-lg p-4 shadow-[var(--shadows-sm)] flex flex-col" data-id="element-2832">
          <div className="flex items-center gap-3 mb-4" data-id="element-2833">
            <AppLogo appId={app.id} size="lg" data-id="element-2834" />
            <div className="min-w-0" data-id="element-2835">
              <h3 className="font-medium text-[var(--colors-text-primary)] truncate" data-id="element-2836">
                {app.name}
              </h3>
              <div className="flex items-center gap-1.5 mt-0.5" data-id="element-2837">
                <span className={`w-2 h-2 rounded-full ${app.status === 'Connected' ? 'bg-[var(--colors-success-dark)]' : app.status === 'Needs reauth' ? 'bg-[var(--colors-error-dark)]' : 'bg-[var(--colors-neutral-400)]'}`} data-id="element-2838" />
                <span className="text-xs text-[var(--colors-text-tertiary)]" data-id="element-2839">
                  {app.status}
                </span>
              </div>
            </div>
          </div>

          <div className="flex-1" data-id="element-2840">
            {app.accountName ? <div className="text-sm text-[var(--colors-text-secondary)]" data-id="element-2841">
                {app.accountName}
              </div> : <div className="text-sm text-[var(--colors-text-tertiary)] italic" data-id="element-2842">
                No account linked
              </div>}
            {app.lastSync && <div className="text-xs text-[var(--colors-text-tertiary)] mt-1" data-id="element-2843">
                Last sync: {app.lastSync}
              </div>}
          </div>

          <div className="mt-4 pt-4 border-t border-[var(--colors-border-light)] flex justify-end" data-id="element-2844">
            {app.status === 'Connected' && <button className="text-sm text-[var(--colors-text-secondary)] hover:text-[var(--colors-text-primary)] flex items-center gap-1.5 transition-colors" data-id="element-2845">
                <Settings className="w-4 h-4" data-id="element-2846" /> Manage
              </button>}
            {app.status === 'Needs reauth' && <button className="text-sm text-[var(--colors-error-default)] hover:text-[var(--colors-error-dark)] flex items-center gap-1.5 transition-colors" data-id="element-2847">
                <AlertCircle className="w-4 h-4" data-id="element-2848" /> Reconnect
              </button>}
            {app.status === 'Not connected' && <button className="text-sm text-[var(--brand-primary)] hover:text-[var(--brand-primaryhover)] flex items-center gap-1.5 transition-colors" data-id="element-2849">
                <Link2 className="w-4 h-4" data-id="element-2850" /> Connect
              </button>}
          </div>
        </div>)}
    </div>;
}